import { BattingLineup } from "./batting-lineup";
import { PitchingLineup } from "./pitching-lineup";

export const GameLineups = (props) => {
  const { battingLineups = [], pitchingLineups = [], homeTeam, awayTeam, homeTeamId, awayTeamId } = props;

  const awayBatting = battingLineups.filter((p) => p.team_id === awayTeamId);
  const homeBatting = battingLineups.filter((p) => p.team_id === homeTeamId);
  const awayPitching = pitchingLineups.filter((p) => p.team_id === awayTeamId);
  const homePitching = pitchingLineups.filter((p) => p.team_id === homeTeamId);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <BattingLineup lineup={awayBatting} teamName={awayTeam} teamId={awayTeamId} />
        <BattingLineup lineup={homeBatting} teamName={homeTeam} teamId={homeTeamId} />
      </div>
      <div className="grid grid-cols-2 gap-6">
        <PitchingLineup lineup={awayPitching} teamName={awayTeam} teamId={awayTeamId} />
        <PitchingLineup lineup={homePitching} teamName={homeTeam} teamId={homeTeamId} />
      </div>
    </div>
  );
};
